import { useMemo } from 'react';

import { IGroupConditionForm } from '../PassportGroupFormModule/interfaces/IGroupConditionForm';
import { KnmCollapse } from '../../KnmPackage/MainModule/components/KnmCollapse';
import { PassportGroupPassportTypeEnum } from '../PassportGroupFormModule/enums/PassportGroupPassportTypeEnum';
import { PassportGroupDetailCommonConditions } from './PassportGroupDetailCommonConditions';
import { PassportGroupDetailStatusConditions } from './PassportGroupDetailStatusConditions';
import { PassportGroupDetailAssignmentConditions } from './PassportGroupDetailAssignmentConditions';
import { PassportGroupDetailSubjectConditions } from './PassportGroupDetailSubjectConditions';
import { PassportGroupDetailObjectConditions } from './PassportGroupDetailObjectConditions';
import { PassportGroupDetailEventConditions } from './PassportGroupDetailEventConditions';
import { PassportGroupDetailEventSubjectConditions } from './PassportGroupDetailEventSubjectConditions';

interface IPassportGroupDetailConditionProp {
  condition: IGroupConditionForm;
}

export const PassportGroupDetailCondition = ({ condition }: IPassportGroupDetailConditionProp) => {
  const subTitle = useMemo(() => {
    switch (condition.category) {
      case PassportGroupPassportTypeEnum.ERKNM:
        return 'Контрольные (надзорные) мероприятия';
      case PassportGroupPassportTypeEnum.PM:
        return 'Профилактические мероприятия';
      case PassportGroupPassportTypeEnum.DECISION_PASSPORT:
        return 'Решения (КНМ, ПМ без взаимодействия, СР)';
      case PassportGroupPassportTypeEnum.ERP:
        return 'Проверки ЕРП';
      default:
        return undefined;
    }
  }, [condition]);

  return (
    <KnmCollapse title={condition.name} subtitle={subTitle}>
      <>
        <PassportGroupDetailCommonConditions condition={condition.commonConditions} category={condition.category} />
        <PassportGroupDetailAssignmentConditions condition={condition.assignmentConditions} />
        <PassportGroupDetailSubjectConditions condition={condition.subjectConditions} />
        <PassportGroupDetailObjectConditions condition={condition.objectConditions} />
        <PassportGroupDetailEventSubjectConditions
          condition={condition.eventSubjectConditions}
          category={condition.category}
        />
        <PassportGroupDetailEventConditions condition={condition.eventConditions} />
        <PassportGroupDetailStatusConditions condition={condition.statusConditions} category={condition.category} />
      </>
    </KnmCollapse>
  );
};
